import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { MetricsDashboard } from '@/components/metrics/MetricsDashboard';

/**
 * Metrics page component that displays the metrics dashboard
 * Premium 10/10 design with subtle gradient background
 */
const Metrics = () => {
  const [searchParams] = useSearchParams();
  const videoId = searchParams.get('videoId');
  
  return (
    <Layout fixedSidebar>
      <div 
        className="flex-1 flex flex-col overflow-hidden"
        style={{
          background: 'linear-gradient(180deg, #FFFFFF 0%, #F9FAFF 100%)'
        }}
      >
        <div className="hidden lg:block h-px bg-border w-full" />
        <main className="flex-1 flex flex-col overflow-hidden">
          <MetricsDashboard initialVideoId={videoId} />
        </main>
      </div>
    </Layout>
  );
};

export default Metrics;
